import Vue from 'vue'
import api from '@/api'

export const lookup = {
  namespaced: true,
  state: {
    lookups: {
      // 'contact.titleid': [],
      // 'currency': [],
      // 'billing.periodid': [],
      // 'business.statusid': [],
      // 'businessaddress.typeid': [],
      // 'businessinfo.annualrevenueid': [],
      // 'businessinfo.corporateaccountid': [],
      // 'businessinfo.dispatchpriorityid': [],
      // 'businessinfo.locationcountid': [],
      // 'businessinfo.monthlyrosid': [],
      // 'businessinfo.referralsourceid': [],
      // 'businessinfo.oemcertid': [],
      // 'businessinfo.salesrep': [],
      // 'businessinfo.distributor': [],
      // 'user.typeid': [],
      // 'discountmapping.mappingtypeid': [],
      // 'productdiscount.discounttypeid': []
    },
    timezones: [],
    states: [],
    products: [],
    insuranceCompanies: [],
    vehicleManufacturers: []
  },
  getters: {
    lookups: state => state.lookups,
    timezones: state => state.timezones,
    states: state => state.states,
    insuranceCompanies: state => state.insuranceCompanies,
    vehicleManufacturers: state => state.vehicleManufacturers,
    products: state => state.products
  },
  actions: {
    getLookups ({ commit }, keys) {
      return new Promise((resolve, reject) => {
        api.lookups(keys, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_LOOKUPS', { keys, data: response.data })
            resolve(response)
          })
      })
    },
    upsertLookup ({ commit }, lookup) {
      return new Promise((resolve, reject) => {
        api.upsertLookup(lookup)
          .then(response => {
            lookup.id = response.data
            if (response.status === 200) {
              commit('SET_LOOKUP', lookup)
            }
            resolve(response)
          })
      })
    },
    upsertProduct ({ commit }, product) {
      return new Promise((resolve, reject) => {
        api.upsertProduct(product)
          .then(response => {
            product.id = response.data
            if (response.status === 200) {
              commit('SET_PRODUCT', product)
            }
            resolve(response)
          })
      })
    },
    getTimeZones ({ commit }) {
      return new Promise((resolve, reject) => {
        api.getTimeZones()
          .then(response => {
            commit('SET_TIMEZONES', response.data)
            resolve(response)
          })
      })
    },
    getStates ({ commit }) {
      return new Promise((resolve, reject) => {
        api.getStates()
          .then(response => {
            commit('SET_STATES', response.data)
            resolve(response)
          })
      })
    },
    getInsuranceCompanies ({ commit }) {
      api.getInsuranceCompanies()
         .then(response => {
           if (response.status === 200) {
             commit('SET_INSURANCE_COMPANIES', response.data)
           }
         })
    },
    getVehicleManufacturers ({ commit }) {
      api.getVehicleManufacturers()
         .then(response => {
           if (response.status === 200) {
             commit('SET_VEHICLE_MANUFATURERS', response.data)
           }
         })
    },
    getProducts ({ commit }) {
      return new Promise((resolve, reject) => {
        api.getProducts()
          .then(response => {
            commit('SET_PRODUCTS', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    }
  },
  mutations: {
    SET_LOOKUPS (state, {keys, data}) {
      if (typeof keys === 'object') {
        keys.forEach(x => {
          Vue.set(state.lookups, x, data.filter(l => l.key === x))
        })
      } else {
        Vue.set(state.lookups, keys, data)
      }
    },
    SET_LOOKUP (state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup)
      } else {
        var index = state.lookups[lookup.key].findIndex(i => i.id === lookup.id)
        state.lookups[lookup.key].splice(index, 1)
      }
    },
    SET_PRODUCT (state, product) {
      if (product.isActive) {
        state.products.push(product)
      } else {
        var index = state.products.findIndex(i => i.id === product.id)
        state.products.splice(index, 1)
      }
    },
    SET_TIMEZONES (state, timezones) {
      state.timezones = timezones || []
    },
    SET_STATES (state, states) {
      state.states = states || []
    },
    SET_INSURANCE_COMPANIES (state, insuranceCompanies) {
      state.insuranceCompanies = insuranceCompanies || []
    },
    SET_VEHICLE_MANUFATURERS (state, vehicleManufacturers) {
      state.vehicleManufacturers = vehicleManufacturers || []
    },
    SET_PRODUCTS (state, products) {
      state.products = products || []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookup/index.js